<template>
    <div class="video-uploader">
      <h2>Upload and Process Video</h2>
      <input type="file" @change="handleVideoUpload" accept="video/*" />
      <p v-if="processing">Processing video... Please wait.</p>
      <p v-if="error">{{ error }}</p>
      <video v-if="uploadedVideoURL" :src="uploadedVideoURL" controls style="width: 100%; margin-top: 20px;"></video>
  
      <div v-if="segments.length > 0">
        <h3>Video Segments</h3>
        <div v-for="(segment, index) in segments" :key="index" style="margin-bottom: 10px;">
          <p>Segment {{ index + 1 }}</p>
          <video :src="segment.url" controls style="width: 100%;"></video>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
  
  export default {
    data() {
      return {
        uploadedVideo: null,
        uploadedVideoURL: null,
        segments: [],
        processing: false,
        error: null,
      };
    },
    methods: {
      async handleVideoUpload(event) {
        const file = event.target.files[0];
        if (!file) {
          this.error = "No file selected.";
          return;
        }
  
        this.error = null;
        this.segments = [];
        this.uploadedVideo = file;
        this.uploadedVideoURL = URL.createObjectURL(file);
  
        await this.processVideo(file);
      },
      async processVideo(file) {
        this.processing = true;
  
        try {
          const ffmpeg = createFFmpeg({ log: true });
          await ffmpeg.load();
  
          // Load the video into ffmpeg
          const fileName = "input.mp4";
          ffmpeg.FS("writeFile", fileName, await fetchFile(file));
  
          // Get video duration
          const metadata = await ffmpeg.run("-i", fileName);
          const durationMatch = metadata.match(/Duration: (\d+):(\d+):(\d+\.\d+)/);
          if (!durationMatch) {
            throw new Error("Unable to retrieve video duration.");
          }
  
          const hours = parseInt(durationMatch[1], 10);
          const minutes = parseInt(durationMatch[2], 10);
          const seconds = parseFloat(durationMatch[3]);
          const totalDuration = hours * 3600 + minutes * 60 + seconds;
  
          // Generate 1-minute segments
          const segmentDuration = 60; // 60 seconds
          for (let start = 0; start < totalDuration; start += segmentDuration) {
            const outputFileName = `segment-${start}.mp4`;
            await ffmpeg.run(
              "-i",
              fileName,
              "-ss",
              String(start),
              "-t",
              String(segmentDuration),
              "-c",
              "copy",
              outputFileName
            );
  
            // Read and store the segment
            const data = ffmpeg.FS("readFile", outputFileName);
            const blob = new Blob([data.buffer], { type: "video/mp4" });
            const url = URL.createObjectURL(blob);
            this.segments.push({ start, url });
  
            // Cleanup the segment file from ffmpeg FS
            ffmpeg.FS("unlink", outputFileName);
          }
        } catch (err) {
          console.error("Error processing video:", err);
          this.error = "Failed to process video. Please try again.";
        } finally {
          this.processing = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .video-uploader {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
  }
  </style>